import "../../../index67.css";
import { jsx as b } from "react/jsx-runtime";
import i from "react";
import { a as L } from "../../../core-DVmjA3_O.js";
import "../../../type-Dku6Xzl6.js";
import S from "../../RawButton/index.js";
import w from "../../TabLayout/index.js";
import A from "../../../contexts/tab.js";
const E = "_tab_1mxwa_1", N = {
  tab: E
};
function z(d) {
  const s = i.useContext(A), {
    styleVariant: o,
    colorVariant: l,
    disabled: f,
    registerTab: n,
    unregisterTab: c,
    setStep: a,
    step: m,
    tabs: u
  } = s, T = u.length, {
    className: x,
    name: t,
    step: e = 0,
    disabled: C,
    children: F,
    errored: _,
    ...h
  } = d;
  i.useEffect(() => (n(t), () => {
    c(t);
  }), [n, c, t]);
  const r = s.activeTab === t;
  i.useEffect(() => {
    r && a && a(e);
  }, [r, a, e]);
  const v = L(m) && m > e, y = o === "step" && e === 1, g = o === "step" && e === T, p = f || C;
  return /* @__PURE__ */ b(
    S,
    {
      className: N.tab,
      onClick: s.setActiveTab,
      name: t,
      disabled: p,
      type: "button",
      children: /* @__PURE__ */ b(
        w,
        {
          ...h,
          className: x,
          styleVariant: o,
          colorVariant: l,
          errored: _,
          stepCompleted: v,
          isFirstStep: y,
          isLastStep: g,
          disabled: p,
          active: r,
          children: F
        }
      )
    }
  );
}
export {
  z as default
};
